import { createClient } from "@supabase/supabase-js";
const supabaseUrl =  process.env.REACT_APP_SUPABASE_URL;
const supabaseKey =  process.env.REACT_APP_SUPABASE_KEY;
export const supabase = createClient(supabaseUrl, supabaseKey);

// A `.in(column, values)` query puts every value in the request URL. With 100+ uuids
// that URL gets long enough to trip the reverse-proxy's URL/header size limit in front
// of the self-hosted Supabase instance, which fails the request with a 502 (surfaced by
// the browser as a CORS error, since the 502 response carries no CORS headers). Splitting
// into smaller batches keeps each request URL short enough to always go through.
export const fetchInChunks = async (table, selectCols, column, values, chunkSize = 50) => {
  const uniqueValues = [...new Set(values)].filter(Boolean);
  if (uniqueValues.length === 0) return { data: [], error: null };

  const chunks = [];
  for (let i = 0; i < uniqueValues.length; i += chunkSize) {
    chunks.push(uniqueValues.slice(i, i + chunkSize));
  }

  const results = await Promise.all(
    chunks.map((chunk) => supabase.from(table).select(selectCols).in(column, chunk))
  );

  const failed = results.find((r) => r.error);
  if (failed) return { data: null, error: failed.error };

  return { data: results.flatMap((r) => r.data || []), error: null };
};
